// superadminPage.js
import React, { useEffect, useState } from 'react';
import { SERVER_URL } from '../constants/server-type';

export default function SuperAdminPage() {
    const [data, setData] = useState('');

    useEffect(() => {
        fetch('${SERVER_URL}/api/superadmin', {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('accessToken')}` }
        })
            .then(response => response.json())
            .then(data => setData(data.message))
            .catch(err => console.error(err));
    }, []);

    return (
        <div className="form-container">
            <h2>SuperAdmin Page</h2>
            <p>{data}</p>
        </div>
    );
}
